import React from "react";
import Layout from "../MainPageWebsite/Layout";
import { BranchesSection } from "../MainPageWebsite/HomePage/HomePage";
import { useTranslation } from "react-i18next";
import { indexStore } from "../../store/indexStore";

function Branches() {
  const { t } = useTranslation();
  const { branchesLoading, branches, lang, name, settings } = indexStore();
  return (
    <Layout title="branches">
      <BranchesSection
        t={t}
        branches={branches}
        loading={branchesLoading}
        lang={lang}
        name={name}
        openingTime={settings?.opening_time}
        closingTime={settings?.closing_time}
      />
    </Layout>
  );
}

export default Branches;
